import React from 'react';

import NumberMaskedField, { NumberMaskedFieldProps } from '../../NumberMaskedField';

export type ExtFieldProps = NumberMaskedFieldProps;

const defaultProps = {
  /**
   * Using "#" to format the number field adds empty spaces:
   * https://github.com/s-yadav/react-number-format/blob/bbac53d123767458d2d9efab6a370c020b6b011b/src/number_format.js#L207
   * Manually allow up to 6 numbers in the input field. Note that this input only accepts numbers.
   */
  format: (value: string) => {
    return value.length > 6 ? value.slice(0, 6) : value;
  },
};

const ExtensionField = ({ MaskedProps, name, InputProps, ...props }: ExtFieldProps): JSX.Element => {
  return (
    <NumberMaskedField
      fullWidth
      InputProps={{ ...InputProps, name: name }}
      MaskedProps={{ ...MaskedProps, ...defaultProps }}
      {...props}
    />
  );
};

export default ExtensionField;
